import React, { PureComponent } from "react";
import { withWinterMaintence } from "../../../shared/containers/containerWinterMaintence";
import L from "leaflet";
import { Circle } from "react-leaflet";
import WinterMaintenceMapPoup from "./WinterMaintenceMapPoup";
import WinterMaintenceMapUnitRouteLayer from "./WinterMaintenceMapUnitRouteLayer";
import { states } from "../../../reducers/queriesStates";
import booleanPointInPolygon from "@turf/boolean-point-in-polygon";

class WinterMaintenceUnitLayer extends PureComponent {
  isView() {
    const { unit, winterWithoutGroupsFilter, winterGroupsFilter, winterCompaniesRoutesDataState } = this.props;

    if (unit.groups.length === 0 && !winterWithoutGroupsFilter) {
      return false;
    }

    if (unit.groups.length > 0) {
      const isSome = unit.groups.some((group) => {
        return winterGroupsFilter.some((x) => {
          return x === group.id;
        });
      });

      if (!isSome) {
        return false;
      }
    }

    if (winterCompaniesRoutesDataState !== states.NOT_REQUESTED) {
      if (unit.dataRoute === null || unit.dataRoute === undefined) return false;
      if (unit.dataRoute.distance === 0 || unit.dataRoute.route.length === 0) return false;
    }

    return true;
  }

  getPosition() {
    const { winterCompaniesRoutesDataState, unit } = this.props;

    if (winterCompaniesRoutesDataState === states.READY) {
      const i = unit.dataRoute.route.length - 1;
      const j = unit.dataRoute.route[i].length - 1;
      const k = unit.dataRoute.route[i][j].length - 1;
      const lastPosition = unit.dataRoute.route[i][j][k];

      return lastPosition;
    }

    return [parseFloat(unit.lastPosition.data["COOY"]), parseFloat(unit.lastPosition.data["COOX"])];
  }

  getData() {
    const { winterCompaniesRoutesDataState, unit } = this.props;

    if (winterCompaniesRoutesDataState === states.READY) {
      return unit.dataRoute.data[unit.dataRoute.data.length - 1];
    }

    return unit.lastPosition.data;
  }

  render() {
    const { filterArea, findUnitPosition, searchTermWinterUnit, unit, area, parentCompany, company, colorParentCompanies, searchGeoZone } =
      this.props;

    if (unit.lastPosition === null || unit.isView === false) return null;

    if (filterArea.companyId !== null && company.id !== filterArea.companyId) return null;
    if (!this.isView()) return null;

    let color = colorParentCompanies[parentCompany.id];

    if (findUnitPosition !== null && unit.registerNumber.toLowerCase().includes(searchTermWinterUnit)) {
      color = "red";
    }

    const svgRender = L.svg({
      tolerance: 5,
      padding: 1,
    });

    const _unit = { ...unit, areaTitle: area.title, parentCompanyTitle: parentCompany.title, companyTitle: company.title };

    return (
      <div>
        <Circle
          key={unit.id}
          center={this.getPosition()}
          radius={1.5}
          color={"black"}
          fillColor={color}
          opacity={1}
          fillOpacity={0.8}
          weight={2}
          renderer={svgRender}
        >
          <WinterMaintenceMapPoup data={this.getData()} unit={_unit} />
        </Circle>
        <WinterMaintenceMapUnitRouteLayer unit={_unit} color={color} />
      </div>
    );
  }
}

export default withWinterMaintence(React.memo(WinterMaintenceUnitLayer));
